var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.03022 13.0298L13.0605 7.99945L8.03022 2.96912L6.96956 4.02978L10.1892 7.24939H3L3 8.74939H10.1893L6.96956 11.9691L8.03022 13.0298Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
